export default __webpack_public_path__ + "static/mainlogo-84f09fca388c57ed93885963105e122e.svg";